import React from 'react'
import {useIntl} from 'react-intl'

interface PlanBadgeProps {
    accountName: string
    balance: number
    expiryDate?: string
    currency: string
}

// Extract plan type from account name (e.g., "Health Care FSA" -> "FSA")
export const getPlanType = (accountName: string): string => {
    if (accountName.includes('FSA')) return 'FSA'
    if (accountName.includes('HSA')) return 'HSA'
    if (accountName.includes('HRA')) return 'HRA'
    return accountName
}

const PlanBadge: React.FC<PlanBadgeProps> = ({accountName, balance, expiryDate, currency}) => {
    const intl = useIntl()
    const planType = getPlanType(accountName)
    const planBalance = intl.formatNumber(balance, {
        style: 'currency',
        currency
    })

    return (
        <div className="bg-gray-02/80 rounded-full pl-1 pr-3 py-1 flex items-center justify-center align-middle gap-2">
            <span className="bg-gray-03/80 text-white text-xs font-medium rounded-full w-7 h-7 flex items-center justify-center ">
                {planType}
            </span>
            <span className="text-sm font-body text-gray-03">{planBalance}</span>
        </div>
    )
}

export default PlanBadge
